import {getBaseDir,getEnvDir} from './base_dirs.js';
import {make_path} from './path_utils.js';
export function getEnvPath(string:string='.env'):string {
    return make_path(getEnvDir(),string);
};
export function getDbConfigsPath(): string {
    return make_path(getBaseDir(),'dbConfigs');
}
export function getSchemasPath(): string {
    return make_path(getDbConfigsPath(),'schemas');
}
export function getSchemasDirPath(subPath: string): string {
    return make_path(getSchemasPath(),subPath);
}
